import { apiClient, unwrap } from './client';

import type { ApiResponse, LoginFormValues, RegisterFormValues, User } from '@/types';

interface LoginResponse {
  token: string;
  user: User;
}

export interface SecurityQuestionResult {
  username: string;
  has_security_question: boolean;
  security_question: string | null;
}

export async function login(values: LoginFormValues): Promise<LoginResponse> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/auth/login', values);
  return unwrap(response);
}

export async function register(values: RegisterFormValues): Promise<LoginResponse> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/auth/register', values);
  return unwrap(response);
}

export async function fetchCurrentUser(): Promise<User> {
  const response = await apiClient.get<ApiResponse<User>>('/auth/me');
  return unwrap(response);
}

export async function logout(): Promise<void> {
  await apiClient.post<ApiResponse<unknown>>('/auth/logout');
}

export async function getSecurityQuestion(username: string): Promise<SecurityQuestionResult> {
  const response = await apiClient.get<ApiResponse<SecurityQuestionResult>>(
    `/auth/security-question/${encodeURIComponent(username)}`
  );
  return unwrap(response);
}

export async function resetPassword(payload: {
  username: string;
  security_answer: string;
  new_password: string;
}): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>('/auth/reset-password', payload);
  return unwrap(response);
}
